import React from 'react';
import SATextInput from './SATextInput';
import { Row, Col } from 'react-bootstrap';

export default function FullName(props) {
    const register = props?.register;
    const errors = props?.errors;
    return ( 
        <Row>
            <Col lg={4}>
                <SATextInput
                    register={register}
                    htmlFor={props.htmlForLastName}
                    name={props.nameLastName}
                    label={"Last Name:"}
                    isStrong={true}
                    requiredText={"Last Name is required!"}
                    type={"text"}
                    placeholder={"Last Name (required)"}
                    errors={errors}
                    id={props.lastNameId}
                    errMsg={props?.lastNameErrMsg}
                    maxLength={32}
                    requiredObj={{
                        required: "Last Name is required!",
                        pattern: {
                            value: /[\sa-zA-Z'`~.s -]+$/, message: "Invalid Last Name!"
                        }
                    }}

                />
            </Col>
            <Col lg={4}>
                <SATextInput
                    register={register}
                    htmlFor={props.htmlForFirstName}
                    name={props.nameFirstName}
                    label={"First Name:"}
                    isStrong={true}
                    requiredText={"First Name is required!"}
                    type={"text"}
                    placeholder={"First Name (required)"}
                    errors={errors}
                    id={props.firstNameId}
                    errMsg={props?.firstNameErrMsg}
                    maxLength={32}
                    requiredObj={{ required: "First Name is required!",
                    pattern: {
                        value: /[\sa-zA-Z'`~.s -]+$/, message: "Invalid First Name!"
                    } }}
                />
            </Col>
            <Col lg={4}>
                <SATextInput
                    register={register}
                    htmlFor={props.htmlForMiddleName}
                    name={props.nameMiddleName}
                    label={"Middle Name:"}
                    isStrong={false}
                    type={"text"}
                    placeholder={"Middle Name"}
                    errors={errors}
                    maxLength={1}
                />
            </Col>
        </Row>

    )
}